import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./IfilSwap.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.ifilSwapContractAddress;
let ifilcontractAddress = $erc20.getErc20Address('FIL');
let dmccontractAddress = $erc20.getErc20Address('DMC');
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getIfilSwapAddress = () => {
    return contractAddress;
}

const getIfilSwapContract = () => {
    return contractConst.contract;
}



const getIfilcalcFee = async([_filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, ifilcontractAddress);
    return $web3js.call(getIfilSwapContract().methods.calcFee, [_filAmount], options, handleIfilcalcFee);
}


const getAllIfilcalcFee = async([_filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, ifilcontractAddress);
    return $web3js.call(getIfilSwapContract().methods.calcFee, [_filAmount], options);
}


const getAllIfilcalcFeenum = async([_filAmount], options) => {
    _filAmount = await $erc20.toErc20Value(_filAmount, ifilcontractAddress);
    return $web3js.call(getIfilSwapContract().methods.calcFee, [_filAmount], options, handleIfilcalcFeenum);
}
const handleIfilcalcFeenum = async(res) => {


    return await $erc20.fromErc20Value(res, dmccontractAddress);
}



const handleIfilcalcFee = async(res) => {
    let amount = res;
    let formartAmonut = res;
    amount = await $erc20.fromErc20Value(amount, dmccontractAddress);


    return {
        amount,
        formartAmonut
    }
}

const getAllIfilcfg = async([], options) => {
    return $web3js.call(getIfilSwapContract().methods.cfg, [], options, handleIfilcfg);
}

const handleIfilcfg = async(res) => {
    let index = 0;
    let feeRate = res[index++];
    let feeLimit = res[index++];
    let minAmount = res[index++];
    let slippage = res[index++];
    let feeRecvAddress = res[index++];
    let platformAddress = res[index++];
    let maxAmount = res[index++];

    // calcTotalBenefits = await $erc20.fromErc20Value(calcTotalBenefits, pledgeContractAddress);
    minAmount = await $erc20.fromErc20Value(minAmount, $erc20.getErc20Address("DMC"));
    feeLimit = await $erc20.fromErc20Value(feeLimit, $erc20.getErc20Address("DMC"));
    maxAmount = await $erc20.fromErc20Value(maxAmount, $erc20.getErc20Address("DMC"));

    return {
        feeRate,
        feeLimit,
        minAmount,
        slippage,
        feeRecvAddress,
        platformAddress,
        maxAmount
    }
}


const ifilswap = async([_swapType, _to, _toMainet, _amount, _dmcFee], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, ifilcontractAddress);
    return $web3js.send(getIfilSwapContract().methods.swap, [_swapType, _to, _toMainet, _amount, _dmcFee], options, callback);
}

const ifilswapEstimateSend = async([_swapType, _to, _toMainet, _amount, _dmcFee], options) => {

    _amount = await $erc20.toErc20Value(_amount, ifilcontractAddress);
    let gasPromise = $web3js.estimateSend(getIfilSwapContract().methods.swap, [_swapType, _to, _toMainet, _amount, _dmcFee], options);
    let gasPricePromise = $web3js.getGasPrice();


    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }


    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return {
        gas,
        gasPrice,
        fee
    };
}

export default {
    getIfilSwapAddress,
    getIfilSwapContract,
    getAllIfilcalcFee,
    ifilswap,
    ifilswapEstimateSend,
    getIfilcalcFee,
    getAllIfilcfg,
    getAllIfilcalcFeenum
}



// WEBPACK FOOTER //
// ./src/lib/contract/ifilSwap/index.js